import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ProductActivationSettingTranslationFragment } from "@saleor/fragments/types/ProductActivationSettingTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsProductActivationSettingPageProps
  extends TranslationsEntitiesPageProps {
  setting: ProductActivationSettingTranslationFragment;
}

export const fieldNames = {
  activationPcTitle: "activationPcTitle",
  activationPcContent: "activationPcContent",
  activationPcSuccessedTitle: "activationPcSuccessedTitle",
  activationPcSuccessedContent: "activationPcSuccessedContent",
  activationMbTitle: "activationMbTitle",
  activationMbContent: "activationMbContent",
  activationMbSuccessedTitle: "activationMbSuccessedTitle",
  activationMbSuccessedContent: "activationMbSuccessedContent",
  serialNumberPcContent: "serialNumberPcContent",
  serialNumberMbContent: "serialNumberMbContent"
};

const TranslationsProductActivationSettingPage: React.FC<TranslationsProductActivationSettingPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  setting,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              "Translation Product Activation Setting - {languageCode}",
            description: "header"
          },
          {
            languageCode
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Pc Title"
            }),
            name: fieldNames.activationPcTitle,
            translation: maybe(() =>
              setting.translation ? setting.translation.activationPcTitle : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationPcTitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Pc Content"
            }),
            name: fieldNames.activationPcContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationPcContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationPcContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Pc Successed Title"
            }),
            name: fieldNames.activationPcSuccessedTitle,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationPcSuccessedTitle
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationPcSuccessedTitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Pc Successed Content"
            }),
            name: fieldNames.activationPcSuccessedContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationPcSuccessedContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationPcSuccessedContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "SerialNumber Pc Content"
            }),
            name: fieldNames.serialNumberPcContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.serialNumberPcContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.serialNumberPcContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Mobile Title"
            }),
            name: fieldNames.activationMbTitle,
            translation: maybe(() =>
              setting.translation ? setting.translation.activationMbTitle : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationMbTitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Mobile Content"
            }),
            name: fieldNames.activationMbContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationMbContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationMbContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Mobile Successed Title"
            }),
            name: fieldNames.activationMbSuccessedTitle,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationMbSuccessedTitle
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationMbSuccessedTitle)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Activation Mobile Successed Content"
            }),
            name: fieldNames.activationMbSuccessedContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.activationMbSuccessedContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.activationMbSuccessedContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "SerialNumber Mobile Content"
            }),
            name: fieldNames.serialNumberMbContent,
            translation: maybe(() =>
              setting.translation
                ? setting.translation.serialNumberMbContent
                : null
            ),
            type: "short" as "short",
            value: maybe(() => setting.serialNumberMbContent)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsProductActivationSettingPage.displayName =
  "TranslationsProductActivationSettingPage";
export default TranslationsProductActivationSettingPage;
